module.exports = __webpack_public_path__ + "static/media/SkySword.f752aeff.png";